import styled from 'styled-components';

export const Base = styled.div`
	position: fixed;
	z-index: 9000;
	min-width: 200px;
	max-width: 340px;
	width: max-content;
	max-height: 240px;
	overflow-y: auto;
	padding: 4px;
	background-color: ${({ theme }) => theme.gray[0]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 8px;
	box-shadow: 0 6px 20px rgba(0, 0, 0, 0.14);
	scrollbar-width: thin;
`;

export const Row = styled.div<{ $selected: boolean }>`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 5px 8px;
	border-radius: 5px;
	background-color: ${({ $selected, theme }) => ($selected ? theme.blue[500] : 'transparent')};
`;

export const Avatar = styled.div`
	width: 20px;
	height: 20px;
	border-radius: 50%;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 9px;
	font-weight: 600;
	color: #ffffff;
`;

export const Name = styled.div<{ $selected: boolean }>`
	font-size: 13px;
	font-weight: 500;
	white-space: nowrap;
	color: ${({ $selected, theme }) => ($selected ? '#ffffff' : theme.gray[1000])};
`;

export const Email = styled.div<{ $selected: boolean }>`
	font-size: 11px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	min-width: 0;
	color: ${({ $selected, theme }) => ($selected ? 'rgba(255, 255, 255, 0.75)' : theme.gray[600])};
`;
